import axios from "axios";

// Get all custom lists for the authenticated user
export const getCustomLists = async (token) => {
  try {
    const { data } = await axios.get("/api/custom-lists", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to fetch groups",
    };
  }
};

// Create a new custom list
export const createCustomList = async (listData, token) => {
  try {
    const { data } = await axios.post("/api/custom-lists", listData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to create group",
    };
  }
};

// Update a custom list
export const updateCustomList = async (listId, listData, token) => {
  try {
    console.log("updateCustomList called with:", { listId, listData });
    
    const { data } = await axios.put(`/api/custom-lists/${listId}`, listData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    console.log("updateCustomList response:", data);
    return data;
  } catch (error) {
    console.error("updateCustomList error:", error);
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to update group",
    };
  }
};

// Delete a custom list
export const deleteCustomList = async (listId, token) => {
  try {
    const { data } = await axios.delete(`/api/custom-lists/${listId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to delete group",
    };
  }
};

// Add a friend to a custom list
export const addFriendToList = async (listId, friendId, token) => {
  try {
    const { data } = await axios.post(
      `/api/custom-lists/${listId}/add-friend`,
      { friendId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to add friend to list",
    };
  }
};

// Remove a friend from a custom list
export const removeFriendFromList = async (listId, friendId, token) => {
  try {
    const { data } = await axios.delete(
      `/api/custom-lists/${listId}/remove-friend/${friendId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to remove friend from list",
    };
  }
};

// Add admin to a custom list
export const addAdminToList = async (listId, userId, token) => {
  try {
    const { data } = await axios.post(
      `/api/custom-lists/${listId}/add-admin`,
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to add admin to list",
    };
  }
};

// Remove admin from a custom list
export const removeAdminFromList = async (listId, userId, token) => {
  try {
    const { data } = await axios.delete(
      `/api/custom-lists/${listId}/remove-admin/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to remove admin from list",
    };
  }
}; 